import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { MemoriesResponse } from './types';

export default function useSaveMemories(queryKey: string[], apiEndpoint: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (markdown: string) => api.put<MemoriesResponse>(apiEndpoint, { markdown }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
